<template>
  <v-container fluid grid-list-md class="padding0">

    <v-layout row wrap mt-4 ml-4 mr-4 m-0 v-if="program">
      <v-flex xs6 text-xs-center offset-xs3 sm3 offset-sm0 md2 lg2 xl1 offset-md2 offset-lg3 offset-xl4>
        <ProgramImage :item="program" @click="openVideo"></ProgramImage>
        <v-progress-linear
          v-if="watchingVideo && watchingVideo.timestamp"
          v-model="watchingVideo.progress"></v-progress-linear>
      </v-flex>

      <Program
        :item="program"
        :watching="watchingVideo"
        @openVideo="openVideo"
        @openVideoFromTimestamp="openVideo(true)"></Program>

      <v-flex xs12 sm6 md6 lg4 class="fixed-width text-align-left hidden-sm-and-up">
        <ProgramDetails :item="program"></ProgramDetails>
      </v-flex>

      <v-flex xs6 text-xs-center offset-xs3 sm3 offset-sm0 md2 lg2 xl1 offset-md2 offset-lg3 offset-xl4 style="display: flex; justify-content: center;">
        <!-- Large Facebook button -->
        <a target="_blank" class="share-btn share-btn-lg share-btn-facebook"
          :href="shareFacebook"
          title="Share on Facebook">
          <v-icon color="primary" class="share-icon">$vuetify.icons.facebook</v-icon>
        </a>

        <!-- Large E-mail button -->
        <a target="_blank" class="share-btn share-btn-lg share-btn-email"
          :href="shareMail"
          title="Share via E-mail">
          <v-icon color="primary" class="share-icon" dark>email</v-icon>
        </a>
      </v-flex>

      <v-flex v-if="program.description" xs12 sm12 md8 lg6 offset-md2 offset-lg3>
        <ProgramDescription :description="program.description" :item="program"></ProgramDescription>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Program from '@/components/Program'
// import Placeholder from '@/components/Placeholder'
import ProgramImage from '@/components/ProgramImage'
import ProgramDetails from '@/components/ProgramDetails'
import TagCarousel from '@/components/TagCarousel'
import ProgramButtons from '@/components/ProgramButtons'
import ProgramDescription from '@/components/ProgramDescription'

import { fun } from '@/config'
import { eventag } from '@/utils'

const verifyReceipt = fun.httpsCallable('verifyReceipt')

export default {
  components: { Program, ProgramImage, ProgramDetails, TagCarousel, ProgramButtons, ProgramDescription },
  data: () => ({
    watchingVideo: null
  }),
  metaInfo() {
    return {
      meta: [
        { property: 'og:url', content: this.shareUrl() },
        { property: 'og:title', content: this.shareDescription },
        { property: 'og:description', content: this.shareDescription },
        { property: 'og:image', content: this.shareImage },
        { property: 'twitter:imag', content: this.shareImage }
      ],
    }
  },
  computed: {
    ...mapGetters(['userData', 'program', 'myList', 'watching', 'isAuthenticated']),
    titleShare() {
      return this.program.title || this.program.slug
    },
    shareTwitter() {
      return `https://twitter.com/share?url=${this.shareShortUrl()}&text=${this.titleShare}`
    },
    shareFacebook() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl()}`
    },
    shareMail() {
      return `mailto:?subject=${this.titleShare}&body=${this.shareUrl()}`
    },
    shareWhatsapp() {
      return `https://api.whatsapp.com/send?text=Microcanales: ${this.titleShare} ${this.shareUrl()}`
    },
    shareImage() {
      return this.program ? (this.program.media && this.program.media.sm ? this.program.media.sm : this.program.image) : ''
    },
    shareTitle() {
      return this.program ? (this.program.title || this.program.slug) : ''
    },
    shareDescription() {
      return this.program ? this.program.description : ''
    }
  },
  methods: {
    ...mapActions(['getProgram', 'getProgramBySlug', 'getShadowProgram']),
    ...mapMutations(['setProgram', 'setProgramSimilars']),
    shareUrl() {
      return window.encodeURIComponent(location.origin + this.$router.currentRoute.fullPath)
    },
    shareShortUrl() {
      return window.encodeURIComponent(location.origin + '/programs/' + this.program.id)
    },
    share() {
      if (navigator.share) {
        navigator.share({
          title: this.program.title || this.program.slug,
          text: this.program.description,
          url: location.href,
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error));
      } else {
        this.snackbar = true
        copyTextToClipboard(location.href)
      }
    },
    async openVideo (timestamp) {
      // await verifyReceipt()
      let video = (await this.program.video_ref.get()).data()
      this.program.video = video
      console.log('PUSH VIDEO')
      this.$router.push({
        name: 'Video',
        params: { slug: this.program.slug },
        query: { timestamp: timestamp }
      })

      eventag({
        eventCategory: 'views',
        eventAction: 'openVideo',
        eventLabel: this.program.slug,
        value: this.userData ? this.userData.id : 'annonymous'
      }, this)
    },
    checkInList (to) {
      if (this.program && this.myList) {
        this.program.inList = !!this.myList.find(i => i.id === this.program.id)
      }
    },
    checkInWatching (to) {
      if (this.program && this.watching) {
        this.watchingVideo = this.watching.find(i => i.id === this.program.id)
      }
    },
    async init (action) {
      this.setProgram(null);
      this.setProgramSimilars()
      // await this.getShadowProgram(this.$route.params.id)
      try {
        if (this.$route.params.id) {
          await this.getProgram(this.$route.params.id)
        } else {
          await this.getProgramBySlug(this.$route.params.slug)
        }
        if (this.$route.query.action) {
          setTimeout(() => {
            this.$store.dispatch(this.$route.query.action, { id: this.program.id })
          }, 1000)
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  created () {
    this.id = this.$route.params.id
    this.init()
  },
  watch: {
    async '$route' (to, from, other) {
      if (to.name === 'Program' && (to.params.id !== this.id || to.params.slug !== this.slug)) {
        this.id = to.params.id
        this.slug = to.params.slug
        await this.init()
      }
    },
    program (to, from, other) {
      if (to) {
        this.checkInList(to)
        if (this.watching) {
          this.checkInWatching(to)
        }
      }
    },
    myList (to, from, other) {
      to && this.checkInList(to)
    },
    watching (to, from, other) {
      to && this.checkInWatching(to)
    }
  }
}
</script>

<style>
  .padding0 {
    padding: 0 !important;
    margin-bottom: 100px;
    margin-top: 50px;
  }
  .v-progress-linear {
    margin: 0 !important;
    height: 4px !important;
  }

  .theme--light.application {
    background: black;
    color: white;
  }
</style>
